import { css, SerializedStyles } from '@emotion/react';

import styled from '@emotion/styled';

import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';

    import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';

import { withConfig } from 'src/withConfig';



const setScoreGroup = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {

    if (variant === DefaultComponentVariantType.SECONDARY) {

        return css`

            border-radius: ${theme.star.radius.small};

            overflow: hidden;

            border: 1px solid ${theme.star.selection.borderColor};

            margin: 0 4px 0 0;

        `;

    }

    return css`

        margin: 0;

    `;

};



interface ScoreGroupPropsType {

    variant: DefaultComponentVariantType | null;

}

export const ScoreGroup = withConfig(theme => styled('div', { label: 'ScoreGroup' })<ScoreGroupPropsType>`

    display: flex;

    flex: 0 0 24px;

    justify-content: center;

    margin: -36px 0 0 0;

    padding-bottom: 12px;

    @media ${theme.star.mediaQuery.desktop} {

        ${({ variant }):SerializedStyles => setScoreGroup(variant, theme)}

        flex-flow: column nowrap;

        flex: 0 0 36px;

        padding: 0;

        width: 36px;

    }

`);



const setScoreWrapper = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => css`

    background-color: ${theme.star.eventRow.bgColorTertiary};

    border-radius: ${variant === DefaultComponentVariantType.SECONDARY ? theme.star.radius.small : theme.star.radius.xSmall};

    color: ${theme.star.eventRow.txtColorTertiary};

    font-size: ${theme.star.fontSize.small};

    font-weight: ${theme.star.fontWeight.xMedium};

    height: 24px;

    line-height: 1.3334;

    padding: 4px;

    position: relative;

    text-align: center;

    width: 24px;

    @media ${theme.star.mediaQuery.desktop} {

        align-items: center;

        border-radius: ${theme.star.radius.none};

        display: flex;

        height: 50%;

        justify-content: center;

        padding: 0;

        position: static;

        width: 100%;

    }

`;



interface ScorePropsType {

    variant: DefaultComponentVariantType | null;

}



export const ScoreHome = withConfig(theme => styled('span', { label: 'ScoreHome' })<ScorePropsType>`

    ${({ variant }): SerializedStyles =>setScoreWrapper(variant, theme)};

    right: 34px;

`);



export const ScoreAway = withConfig(theme => styled('span', { label: 'ScoreAway' })<ScorePropsType>`

    ${({ variant }): SerializedStyles =>setScoreWrapper(variant, theme)};

    left: 34px;

`);

